import { addLocaleData } from "react-intl";
import enLang from "./entries/en-US";
import esLang from "./entries/es-ES";
import chLang from "./entries/zh-ZH";
import frLang from "./entries/fr-FR";
import twLang from "./entries/zh-HK";
import miLang from "./entries/mi-MI";
import idLang from "./entries/id-ID";
import hiLang from "./entries/hi-HI";

import afLang from "./entries/af-AF";
import deLang from "./entries/de-DE";
import jaLang from "./entries/ja-JA";
import koLang from "./entries/ko-KO";
import thLang from "./entries/th-TH";
import tlLang from "./entries/tl-TL";
import viLang from "./entries/vi-VI";
import arLang from "./entries/ar-AR";
import ruLang from "./entries/ru-RU";
import fiLang from "./entries/fi-FI";

const AppLocale = {
  en: enLang,
  es: esLang,
  zh: chLang,
  fr: frLang,
  hk: twLang,
  mi: miLang,
  id: idLang,
  hi: hiLang,
  af:afLang,
  ar:arLang,
  de:deLang,
  ja:jaLang,
  ko:koLang,
  th:thLang,
  tl:tlLang,
  vi:viLang,
  ru:ruLang,
  fi:fiLang,
};
addLocaleData(AppLocale.en.data);
addLocaleData(AppLocale.es.data);
addLocaleData(AppLocale.zh.data);
addLocaleData(AppLocale.fr.data);
addLocaleData(AppLocale.hk.data);
addLocaleData(AppLocale.mi.data);
addLocaleData(AppLocale.id.data);
addLocaleData(AppLocale.hi.data);
addLocaleData(AppLocale.af.data);
addLocaleData(AppLocale.ar.data);
addLocaleData(AppLocale.de.data);
addLocaleData(AppLocale.ja.data);
addLocaleData(AppLocale.ko.data);
addLocaleData(AppLocale.th.data);
addLocaleData(AppLocale.tl.data);
addLocaleData(AppLocale.vi.data);
addLocaleData(AppLocale.ru.data);
addLocaleData(AppLocale.fi.data);

export default AppLocale;
